import React from "react";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { titleLabels } from "../../Resource/Contents";
import { validationMessage } from "../../Resource/Validation";
import { setValueByKey } from "../../../../../../Shared/Table/Utils/TableUtils";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { Title } from "../../../../../../../Wrap/Constants/Enums/Title";
import { TitleMap } from "../../../../../../Shared/Entities/Maps/TitleMap";
import { DatePicker } from "../../../../../../../react-core/Datepicker/DatePicker";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { ContentDatePicker, ACCEPT_DATE_FORMATS } from "../../../../../../Shared/Entities/Constants/DateConstants";
import { PhysicalAddressType } from "../../../../../../../Wrap/Constants/Enums/Customer/PhysicalAddressType";
import { AddAddress } from "../../../NewBusinessWizard/Components/FullClientDetail/AddAddress";
import { FullClientDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { GenderMap } from "../../../../../../Shared/Entities/Maps/GenderMap";
import { Marital } from "../../../NewBusinessWizard/Resource/Contents";

interface IAddBeneficiaryProps extends IProcessComponentProps {
    data: FullClientDetailModel;
}

interface IAddBeneficiaryState {
    useAddressForCorrespondence: boolean;
}

export class AddBeneficiary extends ProcessComponent<IAddBeneficiaryProps, IAddBeneficiaryState> {
    constructor(props: any) {
        super(props);
        this.state = {
            useAddressForCorrespondence: null,
        };
    }

    isValid() {
        const flag = super.isValid();
        if (!this.props.data.AddressDetails) {
            this.props.showErrorMsgPopUp(["Please fill in residence address"], true);
            return false;
        }
        return flag;
    }

    private onFullClientChange = (changes: { value: any; path: string }[]) => {
        const data = this.props.data;
        let _model = { ...data };
        changes.forEach((change) => {
            _model = setValueByKey(_model, change.path, change.value);
        });
        this.props.onChange({ Individual: _model });
    };

    public render() {
        const { data } = this.props;
        let message = ContentDatePicker.CannotBeInThePast;
        if (data?.PersonalDetails?.DateOfBirth == null) {
            message = ContentDatePicker.CannotBeInTheFuture;
        }
        return (
            <>
                <SelectEditor
                    options={TitleMap.getArray()}
                    cssWrapper="control-size-180"
                    selected={data ? data.PersonalDetails?.Title : Title.Mr}
                    label={"Title"}
                    getText={(option) => TitleMap.getString(option)}
                    onChange={(v) => this.onFullClientChange([{ value: v, path: "PersonalDetails.Title" }])}
                    required={validationMessage.titleValidation}
                />
                <TextBoxEditor
                    cssWrapper="control-size-430"
                    value={data?.PersonalDetails?.GivenName}
                    label={titleLabels.firstNameLabel}
                    onChange={(value) => this.onFullClientChange([{ value: value, path: `PersonalDetails.GivenName` }])}
                    required={validationMessage.firstNameValidation}
                />
                <TextBoxEditor
                    cssWrapper="control-size-430"
                    value={data?.PersonalDetails?.FamilyName}
                    label={titleLabels.surnameLabel}
                    onChange={(value) =>
                        this.onFullClientChange([{ value: value, path: `PersonalDetails.FamilyName` }])
                    }
                    required={validationMessage.surnameValidation}
                />
                <DatePicker
                    label={"Date of birth"}
                    formGroupCssWrapper={"control-size-430"}
                    selected={JsonDateParser.toDateNoOffset(data?.PersonalDetails?.DateOfBirth)}
                    alwaysValidateOnUpdate={false}
                    atLeast={{
                        value: new Date(new Date().setFullYear(new Date().getFullYear() - 120)),
                        errorMessage: message,
                    }}
                    atMost={{
                        value: new Date(),
                        errorMessage: ContentDatePicker.CannotBeInTheFuture,
                    }}
                    showYearDropdown={true}
                    onChange={(v) => {
                        this.onFullClientChange([
                            { value: JsonDateParser.toJsonDateNoOffset(v), path: "PersonalDetails.DateOfBirth" },
                        ]);
                    }}
                    todayButton={ContentDatePicker.Today}
                    isClearable={true}
                    dateFormat={ContentDatePicker.DateFormat}
                    acceptDateFormats={ACCEPT_DATE_FORMATS}
                    required={validationMessage.dateOfBirthValidation}
                />
                <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label={titleLabels.genderLabel}
                    options={GenderMap.getArray()}
                    getText={(option) => GenderMap.getString(option)}
                    onChange={(value) => {
                        this.onFullClientChange([{ value: value, path: `PersonalDetails.Gender` }]);
                    }}
                    selected={data?.PersonalDetails?.Gender}
                    required={validationMessage.genderValidation}
                />
                <SelectEditor
                    options={Marital.options}
                    cssWrapper="control-size-300"
                    getText={(v) => Marital.optionsMap[v]}
                    onChange={(v) => {
                        this.onFullClientChange([{ value: v, path: `PersonalDetails.MaritalStatus` }]);
                    }}
                    selected={Number(data?.PersonalDetails?.MaritalStatus)}
                    label="Marital status"
                    placeholder="Please select"
                    required="Please select marital status"
                />
                <AddAddress
                    label="Residential address"
                    onAddressChange={(v) => this.props.onChange({ Address: v })}
                    address={data?.AddressDetails?.find(
                        (ele) => ele?.PhysicalAddressType == PhysicalAddressType.Residential
                    )}
                    canChooseCountry
                    index={
                        data?.AddressDetails?.length == 0 || !data?.AddressDetails
                            ? 0
                            : !this.props.data?.AddressDetails?.some(
                                  (ele) => ele?.PhysicalAddressType == PhysicalAddressType.Residential
                              )
                            ? 1
                            : data?.AddressDetails?.findIndex(
                                  (ele) => ele?.PhysicalAddressType == PhysicalAddressType.Residential
                              )
                    }
                    onCCMChange={(changes) => {
                        this.onFullClientChange(changes);
                    }}
                    addressType={PhysicalAddressType.Residential}
                    addressList={data?.AddressDetails}
                    resetUseAddressForCorrespondence={() => {}}
                    onRef={(ref) => this.appendChild(ref)}
                    onChange={() => {}}
                    data={null}
                    disabled={false}
                />
            </>
        );
    }
}
